import { render, staticRenderFns } from "./Wizardot6showprint.vue?vue&type=template&id=a4e6b75e&scoped=true&"
import script from "./Wizardot6showprint.vue?vue&type=script&lang=js&"
export * from "./Wizardot6showprint.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot6showprint.vue?vue&type=style&index=0&id=a4e6b75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e6b75e",
  null
  
)

export default component.exports